import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FormState {
  isSubmitting: boolean;
  isPrimaryValid: boolean;
  formPrimaryData: any;
}

const initialState: FormState = {
  isSubmitting: false,
  isPrimaryValid: false,
  formPrimaryData: {},
};

const formContactPrimarySlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    triggerSubmit: (state) => {
      state.isSubmitting = true;
    },
    setPrimaryFormValidity: (state, action: PayloadAction<{ isValid: boolean; formData: any }>) => {
      state.isPrimaryValid = action.payload.isValid;
      state.formPrimaryData = action.payload.formData;
      state.isSubmitting = false; 
    },
    resetFormPrimaryData: (state) => {
      state.isPrimaryValid = false;
      state.isPrimaryValid = true;
      state.formPrimaryData = {};
    },
  },
});

export const { triggerSubmit, setPrimaryFormValidity, resetFormPrimaryData } = formContactPrimarySlice.actions;
export default formContactPrimarySlice.reducer;
